import { SelectOpt, CompanyOpt } from '@/types';

/**
 * query key for ai modules
 */
export const AI_QUERY_KEY = 'aiModules';
export const ITEMS_FOR_COMPANY = 'items4Company';

export const AI_MODULE_ITEM_ACTIONS = ['OMMIT', 'EXPAND'];
export const AI_MODULE_ITEM_ALGORITHMS = [
  'ARC_PERIMETER',
  'SHORTEST_SIDE',
  'PYTHAGORAS',
];

export const emptyAI = {
  label: '',
  moduleType: '',
  companies: [],
  isDefault: 'true',
  status: 'ACTIVE',
  description: '',
};

export const emptyItem4AI = {
  company_id: '',
  item_id: '',
  action: 'OMMIT',
  expanded_item: '',
  formula: '',
  correction_factor: 1,
};

export type Item4AI = {
  ai_module_id: number;
  company_id: number;
} & Item4Company;

export type Item4Company = {
  item_id: string;
  action: string;
  expanded_item_id?: string;
  expansion_length_formula?: string;
  /** float number could be very tiny */
  formula_correction_factor?: number;
  /** delete operation mark */
  deleting?: boolean;
};

export type Item4AIPayload = {
  /** aka, company_id */
  company_id: string;
  item_id: string;
  action: string;
  expanded_item: string;
  formula: string;
  correction_factor: number;
};

export type AIModulePayload = {
  /**
   * to edit an AI, this is a must to have
   */
  id?: number;
  label: string;
  moduleType: string;
  companies: SelectOpt[];
  isDefault: string;
  status: string;
  description: string;
};

export type AIModuleEntity = {
  /** AI module id */
  id: number;
  ai_module_key: string;
  back_module_key: string;
  description: string;
  status: string;
  is_default: boolean;
  companies?: CompanyOpt[];
  date_created: string;
  date_modified: string;
};

export const aiEntityToPayload = (
  aiOrEmpty: AIModuleEntity | object
): AIModulePayload => {
  if (!Object.hasOwn(aiOrEmpty, 'id')) return emptyAI;
  const ai = aiOrEmpty as AIModuleEntity;
  return {
    id: ai.id, // ! remmeber to have this to enable save change!
    label: ai.ai_module_key,
    moduleType: ai.back_module_key,
    // for general AI module `companies` is undefined
    companies: (ai.companies || []).map((c) => ({ ...c, value: c.company_id })),
    isDefault: `${ai.is_default}`,
    status: ai.status,
    description: ai.description,
  };
};
